const product = {
  product: "ผลิตภัณฑ์", // translated
  products: "สินค้า", // translated
  information: "ข้อมูล", // translated
  additionalInformation: "ข้อมูลเพิ่มเติม", // translated
  contactUs: "ติดต่อเรา", // translated
  contactUsText: "ต้องการปรับแต่งทัวร์ของคุณหรือมีคำถามอื่น ๆ หรือไม่?", // translated
  dropUsAnEmail: "ส่งอีเมลถึงเรา", // translated
  viewLess: "ดูน้อยลง", // translated
  viewMore: "ดูเพิ่มเติม", // translated
  less: "น้อย", // translated
  more: "มากกว่า", // translated
  highlights: "ไฮไลท์", // translated
  inclusions: "การรวม", // translated
  exclusions: "ข้อยกเว้น", // translated
  pleaseWait: "โปรดรอ...", // translated
  tourType: "ประเภททัวร์", // translated
  search: "ค้นหา", // translated
  available: "มีอยู่", // translated
  availableTours: "ทัวร์ที่มีจำหน่าย", // translated
  sortBy: "เรียงตาม", // translated
  priceLowToHigh: "ราคา: จากต่ำไปสูง", // translated
  priceHighToLow: "ราคา: สูงไปต่ำ", // translated
  mostPopular: "ที่นิยมมากที่สุด", // translated
  roomOnly: "ห้องเท่านั้น", // translated
  bedAndBreakfast: "ที่พักพร้อมอาหารเช้า", // translated
  halfBoard: "ฮาล์ฟบอร์ด", // translated
  fullBoard: "อาหารสามมื้อ", // translated
  allInclusive: "รวมทุกอย่าง", // translated
  viewDetails: "ดูรายละเอียด", // translated
  close: "ปิด", // translated
  at: "ที่", // translated
  person: "บุคคล", // translated
  cancellationPolicy: "นโยบายการยกเลิก", // translated
  cancellationIs: "การยกเลิกคือ", // translated
  to: "ถึง", // translated
  bookingRemarks: "หมายเหตุการจอง", // translated
  totalPrice: "ราคารวม", // translated
  back: "กลับ", // translated
  bookNow: "จองตอนนี้", // translated
  minutes: "นาที", // translated
  visitDuration: "เยี่ยมชมระยะเวลา", // translated
  itinerary: "กำหนดการเดินทาง", // translated
  airportToHotel: "สนามบินถึงโรงแรม", // translated
  hotelToAirport: "โรงแรมไปสนามบิน", // translated
  details: "รายละเอียด", // translated
  servicesDetails: "รายละเอียดบริการ", // translated
  services: "บริการ", // translated
  day: "วัน", // translated
  next: "ต่อไป", // translated
  nextStep: "ขั้นตอนต่อไป", // translated
  skip: "ข้าม", // translated
  remarks: "หมายเหตุ", // translated
  optional: "ไม่จำเป็น", // translated
  guests: "แขก", // translated
  payment: "การชำระเงิน", // translated
  pickup: "หยิบ", // translated
  featuredPackage: "แพ็คเกจแนะนำ", // translated
  flights: "เที่ยวบิน", // translated
  accommodation: "ที่พัก", // translated
  transfers: "การโอน", // translated
  tours: "ทัวร์", // translated
  experiences: "ประสบการณ์", // translated
  featuredTour: "ทัวร์แนะนำ", // translated
  From: "จาก", // translated
  Accommodation: "ที่พัก", // translated
  approxDuration: "ประมาณ ระยะเวลา", // translated
  travellerInformation: "ข้อมูลผู้เดินทาง", // translated
  bookingOverview: "ภาพรวมการจอง", // translated
  checkout: "เช็คเอาท์", // translated
  paymentFailed: "การชำระเงินล้มเหลว", // translated
  paymentSuccess: "ความสำเร็จในการชำระเงิน", // translated
  night: "กลางคืน", // translated
  nights: "คืน", // translated
  viewEscapes: "ดูการหลบหนี", // translated
  viewExperience: "ดูประสบการณ์", // translated
  escapeType: "ประเภทการหลบหนี", // translated
  adultsOnly: "ผู้ใหญ่เท่านั้น", // translated
  totalDuration: "ระยะเวลารวม", // translated
  options: "ตัวเลือก", // translated
  departingAirport: "สนามบินขาออก", // translated
  childrenAreNotAllowedInThisTour: "ไม่อนุญาตให้เด็กเข้าร่วมทัวร์นี้", // translated
};


export default product;
